// 호스트
export const HOST = process.env.REACT_APP_HOST;
export const WS_HOST = process.env.REACT_APP_WS_HOST;
export const NAVER_SEARCH_API_HOST = process.env.NAVER_SEARCH_API_HOST;

export const IMG_PATH = process.env.REACT_APP_IMAGE_HOST;

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

// API KEY
export const NAVER_APP_CLIENT_KEY = process.env.NAVER_APP_CLIENT_KEY;
export const NAVER_APP_SECRET_KEY = process.env.NAVER_APP_SECRET_KEY;

// WINDY API KEY
export const WINDY_KEY = process.env.REACT_WINDY_KEY;
// 기상청 API KEY
export const WHEATHER_KEY = process.env.REACT_WHEATHER_KEY;
// 통신 코드
export const HTTP_STATUS_CODE = {
  OK: '00000'
};

//r6RMUsk3Vtama7D6uq7MiWV9dTC9MwfIIr4%2F45y0uVNw6BaYbgpKmL%2BLUDFVTfIYUmEe4K%2FaniEjdV9mg5t82Q%3D%3D
export const FORM_PROC_TYPE = {
  SELECT: 'R',
  CREATE: 'C',
  UPDATE: 'U',
  DELETE: 'D',
  NONE: ''
};
export const ROLE = {
  NONE: 'ROLE_NONE',
  // USER: 'ROLE_USER',
  USER: 'USER',
  ADMIN: 'ROLE_ADMIN'
};

export const ACCOUNT = {
  cstrmDivCd: 'MEMBER',
  cstrmStatusCd: 'A',
  // authId: 'ROLE_USER',
  authId: 'USER',
  siteCode: 'DRON',
  joinCrtfyCd: 'HP_CRTFD'
};

export const DUPLATE_MESSAGE = {
  message: '이미 존재합니다.',
  code: 'DT001'
};

export const ERROR_MESSAGE = {
  message: '처리중 오류가 발생하였습니다',
  code: '-1'
};

export const SAVE_MESSAGE = {
  message: '저장을 완료하였습니다.',
  code: '1'
};

export const DELETE_MESSAGE = {
  message: '삭제를 완료하였습니다.',
  code: '1'
};

// 코드 정의

export const WGHT_TYPE_CD = [
  {
    code: '-250G',
    codeNm: '최대이륙중량 250g이하'
  },
  {
    code: '250G+2KG-',
    codeNm: '250g 초과 ~ 2kg이하'
  },
  {
    code: '2KG+7KG-',
    codeNm: '2kg초과 ~ 7kg이하'
  },
  {
    code: '7KG+25KG-',
    codeNm: '7kg초과 ~ 25kg이하'
  },
  {
    code: '25KG+',
    codeNm: '25kg 초과'
  }
];

export const ARCTFT_TYPE_CD = [
  {
    code: '01',
    codeNm: '무인 비행기'
  },
  {
    code: '02',
    codeNm: '무인 헬리콥터'
  },
  {
    code: '03',
    codeNm: '무인 멀티콥터'
  },
  {
    code: '04',
    codeNm: '무인 비행선'
  }
];
